import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ToyIcon: React.FC<Props> = (props) => {
  return (
    <svg
      {...props}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="25.0374"
        cy="14.9632"
        r="10.4027"
        stroke="#999999"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3935 22.3195C24.2678 22.3195 17.6807 15.7323 17.6807 7.60669"
        stroke="#999999"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="30.0364"
        cy="9.96436"
        r="3.33472"
        stroke="#999999"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.442 19.1565C13.7955 22.2748 11.2578 24.8323 8.15233 26.5029L7.60043 26.7997C6.04484 27.6368 5.19386 29.3705 5.48325 31.1132C5.77263 32.8558 7.13829 34.2215 8.88094 34.5109C10.6236 34.8002 12.3573 33.9493 13.1944 32.3937L13.4912 31.8418C15.1636 28.7353 17.7235 26.1975 20.8443 24.5521"
        stroke="#999999"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToyIcon;
